import { CustomValidateObj } from 'tdesign-vue/es/form/type';

/**
 * 切换前需要保存的选项卡使用
 * @ddescription c切换标签选项卡时调用，根据状态是否变化，来判断是否需要触发beforeLeave
 * @param toTabValue 跳转前往的标签页value
 * @param $component 跳转前组件本身
 */
export const useToggleTabs = async (toTabValue: string, $component: any) => {
  let result = null;
  if ($component?.$refs?.form) {
    result = await $component?.$refs?.form.validateOnly();
  }
  /**
   * 表单验证结果是否有错误
   * 若有错误，则返回false
   */
  const validateError = (() => {
    // 验证通过，则没有错误
    if (result === true) return false;
    // 验证结果，需要找到对应的错误
    if (result !== null && result !== true) {
      const items: Array<CustomValidateObj[]> = Object.values(result);
      return items.some(validateResults => {
        return validateResults.some(result => result.type === 'error');
      });
    }
    return !result;
  })();
  // 表单有equals值且值相同
  const formIsEqual = $component?.isEqual === true || $component?.isEqual === undefined;
  // 组件内定义的beforeLeave函数
  const beforeLeaveFn = $component?.toggleMethods?.beforeLeave;
  // 若表单相同
  if (formIsEqual || (!formIsEqual && validateError)) {
    return toTabValue;
  }
  if (!beforeLeaveFn) {
    return toTabValue;
  }
  // 返回beforeLeave函数的结果
  return (beforeLeaveFn as any as (v: string) => Promise<string>)(toTabValue);
};
